/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, signal, Output, EventEmitter, input, effect } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { DesyAngularModule } from 'desy-angular';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { getError } from '@/app/utils/form-errors';
import { AiSystemDeployment, Step6Deployment } from '@/app/interfaces/aiSystemDeployment';
import { forceAtLeastOneFieldFilled, setupConditionalRequiredValidation } from '../helpers/validation.helper';
import { binaryOptions } from '../helpers/binary-options.interface';

@Component({
  selector: 'app-deploy-system-of-ia-step-6',
  templateUrl: './deploy-system-of-ia-step-6.component.html',
  styleUrls: ['./deploy-system-of-ia-step-6.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteModule,
    ButtonsComponent,
    DesyAngularModule,
    DatePickerModule,
    SelectButtonModule,
    MultiSelectModule,
  ],
  providers: [ConfirmationService],
})
export class DeploySystemOfIaStep6Component {
  @Output() stepCompleted = new EventEmitter<Step6Deployment>();
  @Output() goToPreviousStep = new EventEmitter<Step6Deployment | null>();

  existingData = input<Partial<AiSystemDeployment>>();

  form: FormGroup;
  getError = getError;

  binaryOptions = binaryOptions;

  formSubmitted = signal(false);
  costBenefitRequired = signal(false);
  costBenefitExtraFilled = signal(false);
  publicValueRequired = signal(false);

  constructor(
    private fb: FormBuilder,
    private router: Router
  ) {
    this.form = this.fb.group({
      costBenefitAnalysis: [null, Validators.required],
      costBenefitAnalysisCsv: null,
      costBenefitAnalysisDescription: [null, Validators.maxLength(500)],
      publicValue: null,
      publicValueDescription: [null, Validators.maxLength(500)],
    });

    setupConditionalRequiredValidation(this.form, this.costBenefitRequired, null, ['costBenefitAnalysis']);
    forceAtLeastOneFieldFilled(this.form, this.costBenefitRequired, this.costBenefitExtraFilled, [
      'costBenefitAnalysisCsv',
      'costBenefitAnalysisDescription',
    ]);

    setupConditionalRequiredValidation(
      this.form,
      this.publicValueRequired,
      ['publicValueDescription'],
      ['publicValue']
    );

    effect(() => {
      const data = this.existingData();
      if (data) {
        this.form.patchValue(data);
      }
    });
  }

  async onSave() {
    const formData = this.form.value;
    this.stepCompleted.emit(formData);
  }

  backPage(): void {
    const formData = this.form.value;
    this.goToPreviousStep.emit(formData);
  }

  cancel(): void {
    this.router.navigate([`/catalogo-ia/sistemas-de-ia/listado-sistemas`]);
  }

  confirm() {
    this.formSubmitted.set(true);
    this.onSave();
  }
}
